import React from 'react';
import { Paper, Box, Button } from '@material-ui/core';

import useBooking from '../../../../context/useBooking';
import useCar from '../../../../context/useCar';
import { useSelector } from 'react-redux';
import { useIsDesktop, useTranslations } from 'components/utilities';

const CarDetailsFooter = ({ boxSizes }) => {
	const { t } = useTranslations();

	const { handleSetContext } = useCar();
	const { togglePaymentMethodsVisible } = useBooking();

	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

	const isDesktop = useIsDesktop()

	const handleBook = () => {
		if ( isAuthenticated ) {
			togglePaymentMethodsVisible();
		} else {
			handleSetContext();
		}
	};

	return (
		<Paper>
			<Box {...boxSizes}>
				<Button
					variant="contained"
					color="primary"
					size={isDesktop ? 'large' : 'medium'}
					fullWidth
					onClick={handleBook}
				>
					{t('car.book')}
				</Button>
			</Box>
		</Paper>
	);
};

export default CarDetailsFooter;
